const state = {
    feedbackId:[],
    loading: false,
};

export default state;